The HTML content of the description.

The maximum length differs by `descriptionId`:

- `AdvertisementDetails` has a maximum length of 15,000 characters.
- `SearchBulletPoint` has a maximum length of 80 characters per bullet point.
- `SearchSummary` has a maximum length of 150 characters.

Scheme requirements:

- The `seekAnz` scheme supports the following HTML tags in `AdvertisementDetails`:

  - `a` (HTTPS only. Available on a per hirer basis. Hirer must contact SEEK to enable.)
  - `b`
  - `br`
  - `div`
  - `em`
  - `h2`
  - `li`
  - `ol`
  - `p`
  - `strong`
  - `ul`

  Other descriptions will have all HTML tags stripped.
